module.exports = __webpack_public_path__ + "static/media/fingerpost.ab007954.png";